<template>
  <el-select :value="value" @change="handleChange" clearable>
    <el-option v-for="(item, index) in dictData" :key="index" v-bind="item">
    </el-option>
  </el-select>
</template>

<script>
import { getDict } from "@/api/baseInfo";
import { mapState } from "vuex";

export default {
  props: {
    typeCode: {
      type: String,
      default: "",
    },
    value: {
      type: [String, Number],
      default: "",
    },
  },
  data() {
    return {
      dictData: [],
    };
  },
  computed: {
    ...mapState({
      dict: "dict",
    }),
  },
  methods: {
    getData() {
      const { dictObj } = this.dict;
      if (dictObj[this.typeCode]) {
        this.dictData = dictObj[this.typeCode];
      } else {
        getDict(this.typeCode).then((res) => {
          const { data = [] } = res;
          this.dictData = data.map((item) => ({
            label: item.name,
            value: item.value,
          }));
          this.$store.dispatch("setDictObj", {
            [this.typeCode]: this.dictData,
          });
        });
      }
    },
    handleChange(val) {
      this.$emit("update:value", val);
      this.$emit("search");
    },
  },
  created() {
    this.getData();
  },
};
</script>

<style lang="scss" scoped></style>
